export default __webpack_public_path__ + "static/media/PlayfairDisplay-Bold.c5eee0d4.ttf";